var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AnalysisTemplateResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.vivace, "/api/");
  }
  getAnalysisTemplatesNames(workspaceId) {
    return __async(this, null, function* () {
      const address = `workspaces/${workspaceId}/AnalysisTemplatesNames`;
      return yield this._get(address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting analysis template names.` })
], AnalysisTemplateResource.prototype, "getAnalysisTemplatesNames", 1);
AnalysisTemplateResource = __decorateClass([
  WPSProxyConverter()
], AnalysisTemplateResource);
const AnalysisTemplateResource$1 = new AnalysisTemplateResource();
export {
  AnalysisTemplateResource$1 as default
};
//# sourceMappingURL=AnalysisTemplateResource.js.map
